export class Discount {
  constructor(data) {
    this.id = data.id;
    this.code = data.code;
    this.packageId = data.packageId;
    this.amountPerUnit = data.amountPerUnit;
    this.amount = data.amount;
    this.appliedQuantity = data.appliedQuantity;
  }
}
